/* assets/firebase-quotes.js */

(function () {
  const firebaseConfig = {
    apiKey: "AIzaSyB_zrPdfFwmztMceUu8l50jCgoM4wesmAs",
    authDomain: "bloomeneur-quotes.firebaseapp.com",
    projectId: "bloomeneur-quotes",
    storageBucket: "bloomeneur-quotes.firebasestorage.app",
    messagingSenderId: "1007321425966",
    appId: "1:1007321425966:web:4a34fb744c3e059c5897bf",
    measurementId: "G-LRR0WJQGY7"
  };

  if (!window.firebaseApp) {
    window.firebaseApp = firebase.initializeApp(firebaseConfig);
    window.firebaseDB = firebase.firestore();
  }

  const db = window.firebaseDB;
  const LOCAL_KEY = 'wishlist_calculations';

  async function saveQuoteToCloud(customerId, quote) {
    if (!customerId) return;
    const payload = {
      ...quote,
      customerId: String(customerId),
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    };
    const ref = await db.collection('quotes').add(payload);
    return { id: ref.id, ...payload };
  }

  async function listQuotesFromCloud(customerId) {
    if (!customerId) return [];
    const snap = await db
      .collection('quotes')
      .where('customerId', '==', String(customerId))
      .orderBy('createdAt', 'desc')
      .get();
    return snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  }

  async function deleteQuotesFromCloud(docIds = []) {
    const batch = db.batch();
    docIds.forEach(id => {
      const ref = db.collection('quotes').doc(id);
      batch.delete(ref);
    });
    await batch.commit();
  }

  async function migrateLocalToCloud(customerId) {
    if (!customerId) return;

    const localQuotes = JSON.parse(localStorage.getItem(LOCAL_KEY) || '[]');
    if (!localQuotes.length) return;

    console.log(`[MIGRACIÓN] Subiendo ${localQuotes.length} cotizaciones locales a Firestore…`);

    for (const q of localQuotes) {
      try {
        await saveQuoteToCloud(customerId, q);
      } catch (e) {
        console.error('[MIGRACIÓN] Error subiendo una cotización:', e);
      }
    }

    // Opcional: conservar local para sesiones futuras sin login
    console.log('[MIGRACIÓN] Conservamos también localStorage.');
  }

  async function smartLoadQuotes(customerId) {
    let local = [];
    try {
      local = JSON.parse(localStorage.getItem(LOCAL_KEY) || '[]');
    } catch (e) {
      console.error('Error parseando localStorage:', e);
    }

    if (customerId) {
      try {
        const cloud = await listQuotesFromCloud(customerId);
        const cloudConsecutives = new Set(cloud.map(q => q.consecutive));
        const onlyLocal = local.filter(q => !cloudConsecutives.has(q.consecutive));
        const merged = [...cloud, ...onlyLocal];
        localStorage.setItem(LOCAL_KEY, JSON.stringify(merged));
        return merged;
      } catch (e) {
        console.error('Error leyendo Firestore:', e);
        return local;
      }
    }

    return local;
  }

  window.QuotesCloud = {
    save: saveQuoteToCloud,
    list: listQuotesFromCloud,
    delete: deleteQuotesFromCloud,
    migrateLocalToCloud,
    smartLoadQuotes,
    LOCAL_KEY
  };
})();

